import { useEffect } from 'react';
import { useSnackbar } from 'notistack';

// Bridge so toasts can be fired from OUTSIDE the React tree
// (redux-sagas, api modules, etc.), where useSnackbar() is not available.
let enqueueSnackbar = null;

/**
 * Renders nothing. Place it inside <SnackbarProvider> in App.js —
 * it captures notistack's enqueueSnackbar into the module reference above.
 */
export function SnackbarUtilsConfigurator() {
    const { enqueueSnackbar: enqueue } = useSnackbar();

    useEffect(() => {
        enqueueSnackbar = enqueue;
        return () => {
            enqueueSnackbar = null;
        };
    }, [enqueue]);

    return null;
}

function show(message, variant, options) {
    if (!enqueueSnackbar) {
        // Provider is not mounted yet — never fall back to blocking alert().
        console.warn('[toast] SnackbarProvider is not mounted yet:', message);
        return;
    }
    enqueueSnackbar(message, {
        variant,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        ...options,
    });
}

export const toast = {
    success: (message, options) => show(message, 'success', options),
    error: (message, options) => show(message, 'error', options),
    warning: (message, options) => show(message, 'warning', options),
    info: (message, options) => show(message, 'info', options),
};
